"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const mobx_1 = require("mobx");
const storage_1 = require("../lib/storage");
const ucParamAjaxHelper_1 = require("../lib/ucParamAjaxHelper");
const fx_1 = require("../lib/fx");
const storeEvent_1 = require("../lib/storeEvent");
class CommentInputStore {
    constructor(config) {
        this.commentTotal = 0;
        this.imageUploadStatus = 'done';
        this.addCommentItem = async (data) => {
            // if (!data.message) {
            //     throw new Error('emoty message');
            // }
            data = this.toApiCommentData(data);
            const newItem = this.toCommentItem(data);
            storeEvent_1.default.sendEvent('commentInput:add:comment', {
                data: {
                    newItem,
                },
            });
            if (this.status !== 'ready') {
                await this.waitReady();
            }
            this.status = 'waiting';
            try {
                if (!data.token) {
                    data.token = this.token;
                }
                const commentData = await ucParamAjaxHelper_1.default.postJsonWithCommonParams(`@{apiHost}/v2/api/comment/add/comment/${this.config.instance}`, data).then((res) => {
                    return new Promise((resolve, reject) => {
                        if (res.status === 0 && res.data.data) {
                            return resolve(res.data.data);
                        }
                        reject(res);
                    });
                });
                newItem.commentId = commentData.id;
                await this.saveItem('comment', newItem);
                mobx_1.runInAction(() => {
                    this.status = 'ready';
                    storeEvent_1.default.sendEvent('commentInput:afterAdd:comment', {
                        data: {
                            newItem,
                        },
                    });
                });
                return newItem;
            }
            catch (ex) {
                console.error(ex);
                this.status = 'ready';
                storeEvent_1.default.sendEvent('commentInput:errorAdd:comment', {
                    data: {
                        newItem,
                    },
                });
            }
        };
        this.addReplyItem = async (data) => {
            if (!data.message) {
                throw new Error('emoty message');
            }
            data = this.toApiCommentData(data);
            const newItem = this.toReplyItem(data);
            this.replyItems.push(newItem);
            storeEvent_1.default.sendEvent('commentInput:add:reply', {
                data: {
                    newItem,
                },
            });
            if (this.status !== 'ready') {
                await this.waitReady();
            }
            this.status = 'waiting';
            try {
                if (!data.token) {
                    data.token = this.token;
                }
                const saveItemPromise = this.saveItem('reply', newItem);
                const postJsonPromise = ucParamAjaxHelper_1.default.postJsonWithCommonParams(`@{apiHost}/v2/api/comment/add/reply/${this.config.instance}`, data);
                const result = await Promise.all([saveItemPromise, postJsonPromise]);
                if (result[1]) {
                    const resData = result[1];
                    const replyId = resData.data && resData.data.data && resData.data.data.id;
                    newItem.replyId = replyId;
                }
                mobx_1.runInAction(() => {
                    this.status = 'ready';
                    storeEvent_1.default.sendEvent('commentInput:afterAdd:reply', {
                        data: {
                            newItem,
                        },
                    });
                });
            }
            catch (ex) {
                console.error(ex);
                this.status = 'ready';
                storeEvent_1.default.sendEvent('commentInput:errorAdd:reply', {
                    data: {
                        newItem,
                    },
                });
            }
        };
        this.init = async () => {
            this.commentItems = this.storage.getItem(`comment/${this.config.itemId}`) || [];
            this.replyItems = this.storage.getItem(`reply/${this.config.itemId}`) || [];
            mobx_1.runInAction(() => {
                this.status = 'ready';
                storeEvent_1.default.sendEvent('commentInput:init:history', {
                    data: {
                        commentItems: this.commentItems,
                        replyItems: this.replyItems,
                    },
                });
            });
        };
        this.deleteSelectImage = () => {
            this.image = '';
            this.imageUploadStatus = 'done';
        };
        this.saveOnlineImage = (onlineImageObj) => {
            this.image = onlineImageObj;
            this.imageUploadStatus = 'done';
        };
        this.toApiCommentData = (data) => {
            data.item_id = this.config.itemId ? this.config.itemId : data.item_id;
            data.comment_id = this.config.commentId;
            data.comment_ref_id = `${data.item_id}_comment`;
            data.user_id = data.user_id || this.config.userId;
            data.user_image = this.getUserImage(data.user_image);
            data.user_name = this.getUserName(data.user_name);
            if (this.getCurrentReplyItem) {
                const currentReplyItem = this.getCurrentReplyItem();
                if (currentReplyItem) {
                    data.message = `${data.message} //@${currentReplyItem.userName}:${currentReplyItem.message}`;
                }
            }
            return data;
        };
        this.toCommentItem = (data) => {
            return {
                isMe: true,
                itemId: this.config.itemId || data.item_id,
                commentId: `${Date.now()}`,
                commentRefId: this.config.itemId ? `${this.config.itemId}_comment` : data.comment_ref_id,
                userId: data.user_id || this.config.userId,
                userImage: data.user_image,
                userName: data.user_name,
                publishTime: Date.now(),
                isWemediaUser: false,
                isWemediaAuthor: false,
                message: data.message,
                replyCount: 0,
                likeCount: 0,
                isLocal: true,
                images: data.image,
            };
        };
        this.toReplyItem = (data) => {
            return {
                itemId: this.config.itemId,
                commentId: this.config.commentId || '',
                commentRefId: `${this.config.itemId}_comment`,
                replyId: `${Date.now()}`,
                userId: data.user_id || this.config.userId,
                userImage: data.user_image,
                userName: data.user_name,
                publishTime: Date.now(),
                isWemediaUser: false,
                isWemediaAuthor: false,
                message: data.message,
                isLocal: true,
                likeCount: 0,
            };
        };
        this.waitReady = () => {
            return new Promise((resolve, reject) => {
                mobx_1.reaction(() => this.status, () => {
                    if (this.status === 'ready') {
                        resolve(true);
                    }
                });
            });
        };
        this.saveItem = async (type, item) => {
            if (type === 'comment') {
                this.commentItems.push(item);
                this.storage.setItem(`${type}/${this.config.itemId}`, mobx_1.toJS(this.commentItems));
            }
            else if (type === 'reply') {
                this.storage.setItem(`${type}/${this.config.itemId}/${this.config.commentId}`, mobx_1.toJS(this.replyItems));
            }
        };
        this.getUserImage = (userImage) => {
            if (userImage && userImage.indexOf('uclocal://') !== -1) {
                return `https://img.uodoo.com/s/uae/g/1s/comment/img/avatar/${userImage.replace('uclocal://', '')}`;
            }
            else if (userImage && userImage.indexOf('http') !== -1) {
                return userImage;
            }
            const defaultUserImageHost = 'https://img.uodoo.com/s/uae/g/1s/comment/img/';
            const defaultUserImages = ['1-min.png', '2-min.png', '3-min.png', '4-min.png', '5-min.png', '6-min.png', '7-min.png', '8-min.png', '9-min.png', '10-min.png'];
            let imageKeyNum = 0;
            const userId = this.config.userId;
            if (!userId) {
                imageKeyNum = Math.floor(Math.random() * 100);
            }
            else {
                const userIdKey = userId.replace(/[^a-zA-Z0-9]/g, '');
                for (let i = 0; i < userIdKey.length; i++) {
                    imageKeyNum += userIdKey.charCodeAt(i);
                }
            }
            return defaultUserImageHost + defaultUserImages[imageKeyNum % defaultUserImages.length];
        };
        this.getUserName = (defaultUserName) => {
            if (defaultUserName) {
                return defaultUserName;
            }
            const userId = this.config.userId;
            const defaultNames = this.config.defaultNames;
            let keyNum = 0;
            if (!userId) {
                keyNum = Math.floor(Math.random() * 100);
            }
            else {
                const userIdKey = userId.replace(/[^a-zA-Z0-9]/g, '');
                for (let i = 0; i < userIdKey.length; i++) {
                    keyNum += userIdKey.charCodeAt(i);
                }
            }
            if (defaultNames && defaultNames.length > 0) {
                return defaultNames[keyNum % defaultNames.length];
            }
            else {
                return '';
            }
        };
        this.onOpenReplyInput = (event) => {
            const data = event.data;
            if ('commentItem' in data) {
                const item = data.commentItem;
                fx_1.callJssdk('comment.openCommentInput', {
                    type: 1,
                    comment_id: item.commentId,
                    comment_ref_id: `${item.itemId}_comment`,
                    reply_user_name: `${item.userName}`,
                    reply_user_id: `${item.userId}`,
                });
            }
            else if ('replyItem' in data) {
                const item = data.replyItem;
                this.getCurrentReplyItem = () => {
                    delete this.getCurrentReplyItem;
                    return item;
                };
                fx_1.callJssdk('comment.openCommentInput', {
                    type: 1,
                    comment_id: item.commentId,
                    comment_ref_id: `${item.itemId}_comment`,
                    reply_id: `${item.replyId}`,
                    reply_user_name: `${item.userName}`,
                    reply_user_id: `${item.userId}`,
                });
            }
        };
        const queries = ucParamAjaxHelper_1.default.getQueriesParams();
        this.config = config;
        this.showInput = this.config.showInput;
        this.autoShowInput = !!queries.auto_comment;
        this.status = 'init';
        this.commentItems = [];
        this.replyItems = [];
        this.storage = new storage_1.LocalStorage('comment/input');
        this.commentTotal = config.commentCount || 0;
        this.token = config.commentToken;
        storeEvent_1.default.addEventHandler('commentInput:open:replyComment', this.onOpenReplyInput);
        storeEvent_1.default.addEventHandler('commentInput:open:replyReply', this.onOpenReplyInput);
        storeEvent_1.default.addEventHandler('commentInput:total:change', (event) => {
            const data = event.data;
            this.commentTotal = data.total;
        });
        this.init();
    }
    readImageFile(file, callback) {
        const fileReader = new FileReader();
        fileReader.onload = ((event) => {
            this.image = event.target.result;
            callback && callback(this.image);
        });
        fileReader.readAsDataURL(file);
    }
    changeImageUploadStatus(status) {
        this.imageUploadStatus = status;
    }
}
tslib_1.__decorate([
    mobx_1.observable,
    tslib_1.__metadata("design:type", Array)
], CommentInputStore.prototype, "commentItems", void 0);
tslib_1.__decorate([
    mobx_1.observable,
    tslib_1.__metadata("design:type", Array)
], CommentInputStore.prototype, "replyItems", void 0);
tslib_1.__decorate([
    mobx_1.observable,
    tslib_1.__metadata("design:type", Number)
], CommentInputStore.prototype, "commentCount", void 0);
tslib_1.__decorate([
    mobx_1.observable,
    tslib_1.__metadata("design:type", Number)
], CommentInputStore.prototype, "commentTotal", void 0);
tslib_1.__decorate([
    mobx_1.observable,
    tslib_1.__metadata("design:type", Boolean)
], CommentInputStore.prototype, "showInput", void 0);
tslib_1.__decorate([
    mobx_1.observable,
    tslib_1.__metadata("design:type", Boolean)
], CommentInputStore.prototype, "autoShowInput", void 0);
tslib_1.__decorate([
    mobx_1.observable,
    tslib_1.__metadata("design:type", Object)
], CommentInputStore.prototype, "config", void 0);
tslib_1.__decorate([
    mobx_1.observable,
    tslib_1.__metadata("design:type", Object)
], CommentInputStore.prototype, "image", void 0);
tslib_1.__decorate([
    mobx_1.observable,
    tslib_1.__metadata("design:type", String)
], CommentInputStore.prototype, "imageUploadStatus", void 0);
tslib_1.__decorate([
    mobx_1.observable,
    tslib_1.__metadata("design:type", String)
], CommentInputStore.prototype, "token", void 0);
tslib_1.__decorate([
    mobx_1.observable,
    tslib_1.__metadata("design:type", String)
], CommentInputStore.prototype, "status", void 0);
tslib_1.__decorate([
    mobx_1.action,
    tslib_1.__metadata("design:type", Object)
], CommentInputStore.prototype, "addCommentItem", void 0);
tslib_1.__decorate([
    mobx_1.action,
    tslib_1.__metadata("design:type", Object)
], CommentInputStore.prototype, "addReplyItem", void 0);
tslib_1.__decorate([
    mobx_1.action,
    tslib_1.__metadata("design:type", Object)
], CommentInputStore.prototype, "init", void 0);
tslib_1.__decorate([
    mobx_1.action,
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [File, Function]),
    tslib_1.__metadata("design:returntype", void 0)
], CommentInputStore.prototype, "readImageFile", null);
tslib_1.__decorate([
    mobx_1.action,
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [String]),
    tslib_1.__metadata("design:returntype", void 0)
], CommentInputStore.prototype, "changeImageUploadStatus", null);
tslib_1.__decorate([
    mobx_1.action,
    tslib_1.__metadata("design:type", Object)
], CommentInputStore.prototype, "deleteSelectImage", void 0);
tslib_1.__decorate([
    mobx_1.action,
    tslib_1.__metadata("design:type", Object)
], CommentInputStore.prototype, "saveOnlineImage", void 0);
exports.default = CommentInputStore;
//# sourceMappingURL=data:application/json;base64,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